package com.partejar.app.feature.contratos.data

data class ContractSetupRequirements(val missingPlan: Boolean, val missingTemplate: Boolean) {
    val isMissing get() = missingPlan || missingTemplate
}

fun ContratoOptions.setupRequirements(contract: Contrato? = null) = ContractSetupRequirements(
    missingPlan = plans.isEmpty() && contract?.planVersionId == null,
    missingTemplate = models.isEmpty() && contract?.modelVersionId == null
)
